module.exports = __webpack_public_path__ + "media/images/workplace/SVG/clickworker-shorties-webapp-ico-f92b985b100da7327dbf9006ccdba81a.svg";